<template>
    <div class="payment-icon">
        <CmsImage
            :data="data.icon"
            :sizes="['56px']"
        />
    </div>
</template>

<script setup lang="ts">
import type { PaymentIconFragment } from '@/graphql/api'

import CmsImage from '@/components/cms/CmsImage.vue'

defineProps<{
    data: PaymentIconFragment
}>()
</script>

<style lang="scss" scoped>
.payment-icon {
    margin: 0 4px;
    flex: 0 0 56px;
    width: 56px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: $border-dark-grey;
    border-width: 2px;
    border-radius: 4px;
    background-color: $white;

    :deep(picture) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
